import request from '@/utils/request'

const preFix = '/education/statistics'

/**
 * 获取教育数据统计总览
 */
export const reqEducationStatistics = () => {
    return request({
        url: preFix + '/overview',
        method: 'get'
    })
}
